module.exports = __webpack_public_path__ + "img/nodeRed-api.a8de79b3.png";